var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('VideoFeaturedSection'),_c('SlideShowSection'),_c('AboutSection'),_c('ProductsSection'),_c('PartnersSection'),_c('ContactSection')],1)}
var staticRenderFns = []

export { render, staticRenderFns }